import { createSlice } from '@reduxjs/toolkit'

import { fetchFieldValues } from 'common/filter/actions/filterFieldValues'

import { FilterFieldValuesState } from './interfaces'

export const initialState: FilterFieldValuesState = {
  query: '',
  items: [],
  isLoading: false,
  isLoaded: false,
  error: null,
}

export const filterFieldValuesSlice = createSlice({
  name: 'values',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFieldValues.pending, (state, action) => {
        state.query = action.meta.arg?.query ?? ''
        state.isLoading = true
        state.error = null
      })
      .addCase(fetchFieldValues.fulfilled, (state, action) => {
        const { query } = action.meta.arg
        if (query !== state.query) return
        state.items = action.payload?.data?.values || []
        state.isLoading = false
        state.isLoaded = true
        state.error = null
      })
      .addCase(fetchFieldValues.rejected, (state, action) => {
        const query = action.meta.arg?.query ?? ''
        if (query !== state.query) return
        state.items = []
        state.isLoading = false
        state.error = action.error?.message || null
      })
  },
})
